import {
  additionalImpressionForRemovableProsthesisItemSchema,
  getBaseProductSchema,
  ItemTypeEnum,
  ProductTypeEnum,
  type AdditionalImpressionForRemovableProsthesisProduct,
} from "@jasper/client-models";
import z from "zod";
import {
  TeethSelectionEnum,
  type ProductWorkflowConfiguration,
} from "./ProductWorkflowConfiguration";
import { StepKeysEnum } from "../../steps/types";
import { ArchStep } from "./constants";

export type AdditionalImpressionForRemovableProsthesisStepKey =
  typeof StepKeysEnum.arch;

const additionalImpressionForRemovableProsthesisArchesSchema = z.object({
  items: z.array(additionalImpressionForRemovableProsthesisItemSchema).min(1),
});

export const AdditionalImpressionForRemovableProsthesisWorkflowConfiguration: ProductWorkflowConfiguration<
  AdditionalImpressionForRemovableProsthesisProduct,
  AdditionalImpressionForRemovableProsthesisStepKey
> = {
  productType: ProductTypeEnum.additionalImpressionForRemovableProsthesis,
  itemType: ItemTypeEnum.additionalImpressionForRemovableProsthesis,
  steps: [new ArchStep()],
  teethSelection: TeethSelectionEnum.ARCH,
  isBulkSupported: true,

  isValidProduct(product) {
    return getBaseProductSchema({
      itemSchema: additionalImpressionForRemovableProsthesisItemSchema,
    }).safeParse(product).success;
  },

  getCompletedSteps(product) {
    return additionalImpressionForRemovableProsthesisArchesSchema.safeParse(
      product
    ).success
      ? [StepKeysEnum.arch]
      : [];
  },
};
